import "../../../../../css/AML/CheckDetails/CheckDetails.css";
import capitalizeFirst from "../../Checks/utils/factories/capitalise";
import dayjs from "dayjs";
import MediaCarousel from "../../Components/Carousel/MediaCarousel";
import TertiaryButton from "../../Components/Buttons/TertiaryButton";
import StatusButton from "../../Components/Buttons/StatusButton";
import { ReactComponent as ArrowUp } from "../../../../../assets/icons/aml/arrowUp.svg";
import UploadNewDocumentModal from "./../HelperFunctions/uploadNewDocumentModal";
import formatAddress from "../../Checks/utils/factories/formatAddress";
import { useState, useMemo, useEffect } from "react";
import {
  uniqueByContext,
  makeMediaSlides,
  isImage,
  isSelfie,
} from "./../HelperFunctions/helperFunctions";
import { useLocation } from "react-router-dom";
import { getCountryName } from "../Utils/getCountryName";
import Banner from "../../Components/Banners/Banner";
import { getHighRiskCountries } from "../Utils/getHighRiskCountries";
import { formatDocumentType } from "../Utils/formatDocumentType";
import { isVeriffSession } from "../Utils/isVeriffSession";
import { colorForResult } from "../Utils/getColorForDecision";

const IDVerification = ({ check, loadCheck, armRefresh }) => {
  // console.log("CALLED");
  const [isPollingDecision, setIsPollingDecision] = useState(false);
  const [open, setOpen] = useState(false);
  const { state } = useLocation();
  const { checkType, sessionId, vendorData, name, sessionUrl } = state || {};
  const [activeAttemptIdx, setActiveAttemptIdx] = useState(0);
  const [showResubmit, setShowResubmit] = useState(false);
  const attemptList =
    check?.attempts?.verifications ??
    check?.attempts?.attempts ??
    (Array.isArray(check?.attempts) ? check.attempts : []) ??
    []; // render
  // Sort attempts: newest first (by createdTime)
  const attemptsSorted = useMemo(() => {
    const arr =
      attemptList?.slice?.() ??
      (Array.isArray(attemptList) ? [...attemptList] : []);
    return arr.sort(
      (a, b) => new Date(b?.createdTime || 0) - new Date(a?.createdTime || 0),
    );
  }, [attemptList]);
  // Build slides for the active attempt (selfies first, then videos)
  const activePrepared = useMemo(() => {
    const a = attemptsSorted[activeAttemptIdx];
    if (!a) return { docSlides: [], portraitAndVideo: [], meta: {} };

    const imgsRaw = a?.media?.images ?? [];
    const vidsRaw = a?.media?.videos ?? [];

    const uniqImgs = uniqueByContext(imgsRaw);
    const uniqVids = uniqueByContext(vidsRaw);

    // A) Document images only
    const docImgs = uniqImgs.filter((img) => isImage(img) && !isSelfie(img));
    const docSlides = makeMediaSlides(docImgs);

    // B) Selfies first, then videos
    const selfieImgs = uniqImgs.filter((img) => isImage(img) && isSelfie(img));
    // const portraitAndVideo = makeMediaSlides([...selfieImgs, ...uniqVids]);

    return {
      docSlides,
      portraitAndVideo: selfieImgs,
      meta: {
        id: a?.attemptId || a?.id || "-",
        status: a?.status || "Not started",
        created: a?.createdTime
          ? dayjs(a.createdTime).format("DD MMM YYYY, HH:mm")
          : "",
      },
    };
  }, [attemptsSorted, activeAttemptIdx]);

  const [highRiskCountries, setHighRiskCountries] = useState([]);

  useEffect(() => {
    async function load() {
      const list = await getHighRiskCountries();
      setHighRiskCountries(list);
    }
    load();
  }, []);

  const docCountry = check?.verification?.document?.country || "";
  const isHighRisk = highRiskCountries.includes(docCountry);

  // Check if the latest attempt (first in sorted array) has videos
  const latestAttemptHasVideo = useMemo(() => {
    const latestAttempt = attemptsSorted[0];
    return latestAttempt?.media?.videos?.length > 0;
  }, [attemptsSorted]);

  // useEffect(() => {
  //   console.log("IDV Check details:", check);
  // }, [check]);

  return (
    <div>
      {check?.verification ? (
        <div className="Result-Section">
          <div
            className="Result-Section-Header"
            onClick={() => setOpen((prev) => !prev)}
            onKeyDown={(e) =>
              (e.key === "Enter" || e.key === " ") && setOpen((v) => !v)
            }
          >
            <div className="AML-Text-Subtitle">
              {checkType === "Enhanced"
                ? "Biometric and Document Verification"
                : "Document Verification"}
            </div>
            <div className="Result-Section-Row ">
              {check?.verification?.status.includes("resubmission") &&
              !isPollingDecision ? (
                <div className="Result-Section-Row">
                  <TertiaryButton
                    buttonText="Resubmit"
                    onClick={() => setShowResubmit(true)}
                  />
                </div>
              ) : null}
              {check?.verification?.status?.toLowerCase() !==
                "resubmission_requested" && (
                <StatusButton
                  type={
                    capitalizeFirst(check?.verification?.status) ||
                    "Not Started"
                  }
                  color={colorForResult(
                    check?.verification?.status?.toLowerCase(),
                  )}
                />
              )}
              <ArrowUp
                className={`collapse-icon ${open ? "collapsed" : ""}`}
                role="button"
                tabIndex={0}
                aria-label={open ? "Expand section" : "Collapse section"}
                aria-expanded={!open}
                // onClick={() => setOpen((prev) => !prev)}
                // onKeyDown={(e) =>
                //   (e.key === "Enter" || e.key === " ") && setOpen((v) => !v)
                // }
              />
            </div>
          </div>
          <div className={`rs-body ${!open ? "is-collapsed" : ""}`}>
            <div className="rs-body-inner">
              {open && (
                <>
                  {check?.verification?.reason && (
                    <div style={{ padding: "0px 16px" }}>
                      <Banner
                        type="error"
                        message={
                          check?.verification?.reason || ""
                          // check?.verification?.reason?.toLowerCase() ===
                          // "suspicious behaviour"
                          //   ? "Suspicious behaviour, this is probably because a scan has been used instead of a photograph."
                          //   : check.verification.reason
                        }
                      />
                    </div>
                  )}
                  {isHighRisk && (
                    <div style={{ padding: "0px 16px" }}>
                      <Banner
                        type="warning"
                        message="This document has been issued by a designated High Risk Country."
                      />
                    </div>
                  )}

                  {/* {latestAttemptHasVideo && (
                    <div style={{ padding: "0px 16px" }}>
                      <Banner
                        type="info"
                        message="The latest attempt was completed by the client."
                      />
                    </div>
                  )}{" "} */}
                  <div className="SubHeader Result-Section-Header">
                    <div className="AML-Text-Subtitle">Data</div>
                  </div>
                  <div className="Data-Row">
                    <div className="Data-Column">
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">First name</div>
                        <div className="AML-Text-Input">
                          {check?.verification?.person?.firstName || ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Last name</div>
                        <div className="AML-Text-Input">
                          {check?.verification?.person?.lastName || ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Date of Birth</div>
                        <div className="AML-Text-Input">
                          {check?.verification?.person?.dateOfBirth
                            ? dayjs(
                                check.verification.person.dateOfBirth,
                              ).format("DD MMM YYYY")
                            : ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Address</div>
                        <div className="AML-Text-Input aml-address">
                          {check?.verification?.person?.addresses?.length
                            ? check.verification.person.addresses.map(
                                (addr, index) => (
                                  <div key={index}>
                                    {formatAddress(addr.fullAddress)}
                                  </div>
                                ),
                              )
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="divider-vertical" />
                    <div className="Data-Column">
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Document Country</div>
                        <div className="AML-Text-Input">
                          {getCountryName(
                            check?.verification?.document?.country,
                          ) || ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Document Type</div>
                        <div className="AML-Text-Input">
                          {formatDocumentType(
                            check?.verification?.document?.type,
                          ) || ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Document number</div>
                        <div className="AML-Text-Input">
                          {check?.verification?.document?.number || ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Date of Issue</div>
                        <div className="AML-Text-Input">
                          {check?.verification?.document?.validFrom
                            ? dayjs(
                                check.verification.document.validFrom,
                              ).format("DD MMM YYYY")
                            : ""}
                        </div>
                      </div>
                      <div className="Check-Details-Section-Row">
                        <div className="AML-Text-Body">Date of Expiry</div>
                        <div className="AML-Text-Input">
                          {check?.verification?.document?.validUntil
                            ? dayjs(
                                check.verification.document.validUntil,
                              ).format("DD MMM YYYY")
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Attempts tabs */}
                  {attemptsSorted.length > 0 ? (
                    <>
                      <div className="SubHeader Result-Section-Header">
                        <div className="AML-Text-Subtitle">Attempt Media</div>
                      </div>
                      <div className="attempt-media-container">
                        <div className="amv-tabs">
                          {attemptsSorted.map((a, idx) => {
                            const isActive = idx === activeAttemptIdx;
                            const statusText = capitalizeFirst(
                              String(a?.status || "Not started"),
                            );

                            return (
                              <button
                                key={a.attemptId || a.id || idx}
                                type="button"
                                className={`amv-tab ${
                                  isActive ? "active" : ""
                                }`}
                                onClick={() => setActiveAttemptIdx(idx)}
                              >
                                <div className="AML-Text-Input">
                                  {statusText}
                                  {/* • Attempt {attemptsSorted.length - idx} */}
                                </div>
                                <div className="AML-Text-Body">
                                  {a?.createdTime
                                    ? dayjs(a.createdTime).format(
                                        "DD MMM YYYY, HH:mm",
                                      )
                                    : "-"}
                                </div>
                              </button>
                            );
                          })}
                        </div>
                        <div className="Data-Row" style={{ maxWidth: "800px" }}>
                          {activePrepared?.portraitAndVideo?.length > 0 && (
                            <div className="Data-Column">
                              <div className="AML-Text-Body">Portrait</div>
                              <MediaCarousel
                                items={activePrepared.portraitAndVideo}
                              />
                            </div>
                          )}

                          {activePrepared?.docSlides?.length > 0 && (
                            <div className="Data-Column">
                              <div className="AML-Text-Body">
                                Document Front and Back
                              </div>
                              <MediaCarousel items={activePrepared.docSlides} />
                            </div>
                          )}
                          {!activePrepared?.portraitAndVideo?.length &&
                            !activePrepared?.docSlides?.length && (
                              <div className="AML-Text-Body">
                                No media submissions.
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="AML-Text-Body"></div>
                    // <div className="AML-Text-Body">No attempts found</div>
                  )}
                </>
              )}
            </div>
            <UploadNewDocumentModal
              open={showResubmit}
              onClose={() => setShowResubmit(false)}
              checkType={checkType.toLowerCase()}
              sessionId={sessionId}
              setIsPollingDecision={setIsPollingDecision}
              onDone={async () => {
                armRefresh?.();
                await loadCheck(true);
                setActiveAttemptIdx(0);
              }}
            />
          </div>
        </div>
      ) : (
        isVeriffSession(checkType) && (
          <div className="Result-Section">
            <div className="Result-Section-Header">
              <div className="AML-Text-Body">
                The client has not yet completed the ID verification. If they
                are unable to locate the email, you can share the session URL
                provided above.
              </div>
              {checkType === "Standard" && !check?.verification && check ? (
                <div className="Result-Section-Row">
                  <TertiaryButton
                    buttonText="Submit Documents"
                    onClick={() => setShowResubmit(true)}
                  />
                  <UploadNewDocumentModal
                    open={showResubmit}
                    onClose={() => setShowResubmit(false)}
                    checkType={checkType.toLowerCase()}
                    sessionId={sessionId}
                    setIsPollingDecision={setIsPollingDecision}
                    onDone={async () => {
                      await loadCheck(true);
                      setActiveAttemptIdx(0);
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        )
      )}
    </div>
  );
};;

export default IDVerification;
